import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import { register } from './serviceWorkerRegistration'; // Disabled - was breaking Supabase auth

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// register(); // Disabled - was breaking Supabase auth
